<template>
	<div id="progressbar" v-if="max && current">
		<input class="range" type="range" :max="max" v-on:input="$emit('progress', Number($event.target.value))" :value="current" />
		{{ dcurrent }} / {{ dmax }}
	</div>
</template>

<script>
export default {
    props: {
        current: { type: Number, required: false},
        max: {type: Number, required: false},
    },
    data: () => { return {
    }},
	methods: {
		prettyTime: function (s) {
			const hours = Math.floor(s / 3600);
			const minutes = Math.floor((s % 3600) / 60)
			const seconds = Math.floor(s % 60)
			var res = '';
			if (hours > 0) {
				res = hours + ':';
			}
			res += (minutes<10 ? '0' : '') + minutes + ':';
			return res + (seconds<10 ? '0' : '') + seconds;
		},
	},
	computed: {
		dmax: function () {
			return this.prettyTime(this.max);
		},
		dcurrent: function () {
			return this.prettyTime(this.current);
		},
	},
}
</script>

<style>

#progressbar {
	width: 100%;
}

#progressbar > input {
	width: 60%;
}

</style>
